// Zentrale API-Adressen: lokal über REACT_APP_API_URL (z. B. http://localhost:5000/api), sonst Produktion.
export const API_BASE = (process.env.REACT_APP_API_URL || 'https://api.ai-pantheon.de/api').replace(/\/+$/, '');
// Statische Dateien (Schulungs-PDFs) liegen neben /api
export const FILE_BASE = API_BASE.replace(/\/api$/, '');
